import { render, staticRenderFns } from "./UserJobPositionInput.vue?vue&type=template&id=16664568&scoped=true&"
import script from "./UserJobPositionInput.vue?vue&type=script&lang=js&"
export * from "./UserJobPositionInput.vue?vue&type=script&lang=js&"
import style0 from "./UserJobPositionInput.vue?vue&type=style&index=0&id=16664568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16664568",
  null
  
)

export default component.exports